import styled, { css } from 'styled-components';

import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import ChevronRight from '@bitcoin-portal/verse-web-components/dist/Icons/ChevronRight';
import {
  TableHeader,
  TableRow,
} from '@bitcoin-portal/verse-web-components/dist/Table';
import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { tabletBreakpoints } from '@context/constants';

import stakingBg from '../../../../assets/stakingbg.png';

// Investments

export const AlertWrapper = styled.div<{
  verse?: boolean;
  flex?: boolean;
}>`
  ${({ theme }) => css`
    margin: ${theme.spacing.unit * 3}px;

    ${media.sm`
            margin: ${theme.spacing.unit * 4}px ${theme.spacing.unit * 5}px;
        `}
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    flex-flow: row nowrap;
    padding: ${theme.spacing.unit * 3}px;

    ${media.sm`
            padding: ${theme.spacing.unit * 5}px ${
      theme.spacing.unit * 5
    }px 0px;
        `}
  `}
`;

export const InvestmentsWrapper = styled.div`
  min-height: 580px;
  height: fit-content;
  padding: 0px !important;
  overflow-y: auto;
`;

// InvestmentsRow
export const PairName = styled.div`
  display: flex;
  flex-flow: column nowrap !important;
  height: fit-content;
  align-items: flex-start;
  @media (min-width: ${tabletBreakpoints.large}) {
    flex-flow: row nowrap !important;
  }
`;

// InvestmentsList
export const TableWrapper = styled.div`
  ${({ theme }) => css`
    display: none;
    @media (min-width: ${tabletBreakpoints.large}) {
      display: flex;
      margin: ${theme.spacing.unit * 4}px 0;
      & > table {
        height: min-content;
      }
      & th {
        height: 44px;
        box-sizing: border-box;
      }
      & td {
        height: 70px;
        box-sizing: border-box;
      }
      & tr:hover {
        // 2nd coin
        & ${PairName} > div:first-child > div:last-child {
          border: 2px solid ${colors.shade20} !important;
        }
      }
    }
  `}
`;

export const ButtonHeader: any = styled(TableHeader)`
  width: 60px;
  ${media.sm`
        width: unset;
    `}
`;

export const FarmsHeader: any = styled(TableHeader)`
  text-align: left;
  padding-left: 40px !important;
  width: 261px;
  box-sizing: border-box;
`;

export const FarmsRow: any = styled(TableRow)<{
  inactive?: boolean;
}>`
  cursor: pointer;
  ${props =>
    props.inactive &&
    css`
      cursor: default;
      filter: grayscale(0.8);
    `}
`;

export const MobileTable = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: stretch;
  @media (min-width: ${tabletBreakpoints.large}) {
    display: none;
  }
`;

// MobileRow
export const MobileRowButton = styled.button<{
  inactive?: boolean;
}>`
  ${({ theme, inactive }) => css`
    width: 100%;
    border: none;
    background: unset;
    border-top: ${theme.border.style} ${theme.palette.border.default};
    border-bottom: ${theme.border.style} ${theme.palette.border.default};
    padding: ${theme.spacing.unit * 2}px 0 19px;
    display: flex;
    flex-flow: column nowrap;
    filter: ${inactive ? 'grayscale(0.8)' : 'none'};

    // First Row
    & > div:first-child {
      display: flex;
      flex-flow: row nowrap;
      width: 100%;

      // CoinPair
      & > div:first-child {
        padding: 0 0 0 ${theme.spacing.unit * 3}px;
      }

      // row content excluding CoinPair
      & > div:last-child {
        box-sizing: border-box;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        padding: 0 ${theme.spacing.unit * 2}px 0;
        width: 100%;
      }
    }

    // 2nd Row
    & > div:last-child {
      box-sizing: border-box;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      padding: 0 ${theme.spacing.unit * 3}px 0;
      width: 100%;

      // each data point
      & > div {
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        margin-bottom: 6px;

        &:last-child {
          margin-bottom: 0px;

          //render reward coin symbol as inline
          & > div:last-child {
            display: flex;
            align-items: center;

            & > div {
              margin-right: 4px;
            }
          }
        }

        & > div:last-child {
          color: ${colors.white};
        }
      }
    }
  `}
`;

// Rewards Container
export const Rewards = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin-right: 4px;
    min-width: 16px;
  }
`;

export const RowButton = styled(Button)`
  width: 74px;

  ${media.sm`
        width: 80px;
    `}
`;

// InvestmentDetail
export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.unit * 3}px;
`;

export const StyledChevron = styled(ChevronRight)`
  transform: rotateZ(180deg);
  color: ${colors.verseBlue};
  cursor: pointer;
  position: absolute;
  top: 48px;
  left: 40px;
`;

export const DetailsWrapper = styled.div<{ bg?: boolean }>`
  ${({ bg }) => css`
    box-sizing: border-box;
    padding: 40px;
    background-image: ${bg ? `url(${stakingBg})` : 'none'};
    background-size: contain;
    background-repeat: no-repeat;

    ${media.sm`
            min-width: 600px;
        `}
  `}
`;

export const InvestmentSummary = styled.div`
  display: grid;
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  grid-template-areas: 'position' 'rewards';

  ${media.sm`
        grid-template-columns: 1fr 1fr;
        grid-template-areas: 'position rewards' 'position rewards' ' buttons buttons';
    `}
`;

export const PositionWrapper = styled.div`
  ${({ theme }) => css`
    grid-area: position;
    display: flex;

    // card
    & > div {
      padding: ${theme.spacing.unit * 2}px;
      align-self: stretch;
      width: 100%;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;

      & h2 {
        padding-top: ${theme.spacing.unit}px;
      }

      ${media.sm`
                padding: ${theme.spacing.unit * 2}px ${
        theme.spacing.unit * 3
      }px;
                border-top-right-radius: unset;
                border-bottom-left-radius: unset;
                border-bottom-right-radius: unset;

                & button {
                    display: none;
                }
            `}
    }
  `}
`;

export const RewardsWrapper = styled.div`
  ${({ theme }) => css`
    grid-area: rewards;
    display: flex;
    // card
    & > div {
      padding: ${theme.spacing.unit * 2}px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: stretch;
      border-radius: 0 0 ${theme.border.radius.small}
        ${theme.border.radius.small};
      flex: 1;
      & > * + * {
        margin-top: ${theme.spacing.unit * 1.5}px;
      }
      ${media.sm`
                padding: ${theme.spacing.unit * 2}px ${
        theme.spacing.unit * 3
      }px;
                border-radius: 0 ${theme.border.radius.small} 0 0;

                & button {
                    display: none;
                }
            `}
    }
  `}
`;

export const CoinWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    & > div:last-child {
      margin-left: ${theme.spacing.unit * 1.5}px;
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: none;
    ${media.sm`
            display: flex;
            grid-area: buttons;
            // card
            & > div {
                padding: ${theme.spacing.unit * 2.25}px ${
      theme.spacing.unit * 3
    }px;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                display: flex;
                flex-flow: row nowrap;
                width: 100%;
            }
        `}
  `}
`;

export const ClaimsSummary = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.unit * 2}px;
    // card
    & > div {
      padding: ${theme.spacing.unit * 2}px;
      background-color: ${colors.verseNavBlue};
      ${media.sm`
                padding: ${theme.spacing.unit * 2}px ${
        theme.spacing.unit * 3
      }px;
            `}
    }
  `}
`;

export const StakingSummary = styled(ClaimsSummary)`
  & > div:first-child {
    overflow: hidden;
    padding: 0px;
    & > div {
      padding: 16px 20px;
    }
  }
`;

export const WithdrawWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.unit * 4}px;
    ${media.sm`
            margin-top: ${theme.spacing.unit * 8.75}px;
        `}
  `}
`;

export const DepositButton = styled(Button)`
  & :disabled {
    background-color: ${colors.shade40};
  }
`;

// NoDetails
export const NoDetailsSummary = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 2px;
    // card
    & > div {
      padding: ${theme.spacing.unit * 2}px;
    }
    & > div:first-child {
      border-radius: 12px 12px 0 0;
    }
    & > div:last-child {
      border-radius: 0 0 12px 12px;
    }
    ${media.sm`
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 2px;
            // card
            & > div {
                padding: 18.5px 23px;

                :first-child {
                    border-radius: 12px 0 0 12px;
                }

                :last-child {
                    border-radius: 0 12px 12px 0;
                }
            }
        `}
  `}
`;

export const LabelWrapper = styled.div`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacing.unit}px;
    ${media.sm`
            padding-bottom: ${theme.spacing.unit * 2}px;
        `}
  `}
`;

export const MessageWrapper = styled.div`
  ${({ theme }) => css`
    box-sizing: border-box;
    margin-top: ${theme.spacing.unit * 2}px;
    // card
    & > div {
      background-color: ${colors.verseNavBlue};
      padding: ${theme.spacing.unit * 2}px;
      ${media.sm`
                padding: ${theme.spacing.unit * 3}px;
            `}
    }
  `}
`;

export const ExpiredFarmSummary = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 2px;
    // card
    & > div {
      padding: ${theme.spacing.unit * 2}px;
    }
    & > div:first-child {
      border-radius: 12px 12px 0 0;
    }
    & > div:last-child {
      border-radius: 0 0 12px 12px;
    }
    ${media.sm`
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 2px;
            // card
            & > div {
                padding: 18.5px 23px;
                :first-child {
                    border-radius: 12px 0 0 0;
                    & > div:first-child {
                      padding: 0 0 5px;
                    }
                }
                :last-child {
                    border-radius: 0 12px 0 0;
                }
            }
        `}
  `}
`;
